// Container imports
const { ADJUST_FOLLOWING_COUNT } = require('./actions')

/* eslint-disable complexity */
function profileUserStatsReducer(state, { type, payload }) {
  switch (type) {
    case ADJUST_FOLLOWING_COUNT:
      return state.merge({
        followers: state.followers + payload.amount
      })
    default:
      return state
  }
}
/* eslint-enable complexity */

module.exports = profileUserStatsReducer
